module.exports = __webpack_public_path__ + "static/media/accept-orders-online.ae55d6e0.png";